import {observer} from "mobx-react-lite";
import {CvvCategoryHeader} from "../components/headers";
import {CvvInputField} from "../components/input";
import {CvvTextInput} from "../components/text_input";
import {FormStepContainer} from "../components/decorations";
import {RefObject, useContext, useRef} from "react";
import {useTheme} from "styled-components";
import {CvvColors, Theme} from "../../theme";
import {MladiVoznikStoreContext} from "./form_mladi_voznik";
import {MladiVoznikStore} from "../../stores/mladi_voznik_store";
import {ReactComponent as NextSvg} from "../../assets/next.svg";
import {CvvButton} from "../../components/buttons";
import {StringFormatters} from "../../utils";
import DatePicker from 'react-date-picker'
import {DatepickerStyles} from "../../components/datepicker_styles";
import {CvvRadio} from "../../components/radio";
import {mladi_voznik} from "../../proto/compiled";
import {CvvCollapsible} from "../../components/collapsible";
import {CvvCheckbox} from "../../components/checkbox";
import {GmapsAddressPicker} from "../components/gmaps";
import {FileUploadInput} from "../components/file_upload";

export const FormMladiVoznikS3 = observer((props: any) => {
    const store = useContext(MladiVoznikStoreContext) as MladiVoznikStore;
    const theme = useTheme() as Theme;
    let nowMinus6M = new Date();
    nowMinus6M.setMonth(nowMinus6M.getMonth() - 6);
    let nowMinus2Y = new Date();
    nowMinus2Y.setFullYear(nowMinus2Y.getFullYear() - 2);
    const dateRef = useRef<HTMLInputElement>();

    return <FormStepContainer>
        <CvvCategoryHeader style={{marginTop: '52px'}}>
            Dodatni podatki
        </CvvCategoryHeader>
        {store.config.s3?.emso && <CvvInputField error={store.validators.step3.emso()} label={'EMŠO'} input={
            <CvvTextInput type={'number'} min={0} maxLength={13} invalid={!!store.validators.step3.emso()}
                          value={store.form.step3!.emso!}
                          pattern={'[0-9]*'}
                          onChange={(e) => store.form.step3!.emso = StringFormatters.numeric(e.target.value)}/>
        }/>}
        {store.config.s3?.stVozniske &&
            <CvvInputField error={store.validators.step3.stVozniske()} label={'ŠTEVILKA VOZNIŠKEGA DOVOLJENJA'} input={
                <CvvTextInput type={'number'} min={0} maxLength={9} invalid={!!store.validators.step3.stVozniske()}
                              value={store.form.step3!.stVozniske!}
                              pattern={'[0-9]*'}
                              onChange={(e) => store.form.step3!.stVozniske = StringFormatters.numeric(e.target.value)}/>
            }/>}
        {store.config.s3?.datumIzdajeVozniske && <CvvInputField error={store.validators.step3.datumIzdajeVozniske()}
                                                                label={'DATUM IZDAJE VOZNIŠKEGA DOVOLJENJA'}
                                                                input={
                                                                    <DatepickerStyles
                                                                        invalid={!!store.validators.step3.datumIzdajeVozniske()}>
                                                                        <DatePicker
                                                                            inputRef={dateRef as RefObject<HTMLInputElement>}
                                                                            value={store.step3!.datumIzdajeVozniske}
                                                                            format={'d. M. y'}
                                                                            onChange={(date?: Date) => store.step3.setDatumIzdajeVozniske(date)}
                                                                            defaultActiveStartDate={nowMinus6M}
                                                                        />
                                                                    </DatepickerStyles>
                                                                }/>}
        {store.config.s3?.datumOpravljenegaIntenzivnegaTecaja &&
            <CvvInputField error={store.validators.step3.datumOpravljenegaIntenzivnegaTecaja()}
                           label={'DATUM OPRAVLJENEGA INTENZIVNEGA TEČAJA'}
                           input={
                               <DatepickerStyles
                                   invalid={!!store.validators.step3.datumOpravljenegaIntenzivnegaTecaja()}>
                                   <DatePicker
                                       inputRef={dateRef as RefObject<HTMLInputElement>}
                                       value={store.step3!.datumOpravljenegaIntenzivnegaTecaja}
                                       format={'d. M. y'}
                                       onChange={(date?: Date) => store.step3.setDatumOpravljenegaIntenzivnegaTecaja(date)}
                                       defaultActiveStartDate={nowMinus6M}
                                   />
                               </DatepickerStyles>
                           }/>}
        {store.config.s3?.letoOpravljenegaIntenzivnegaTecaja &&
            <CvvInputField error={store.validators.step3.letoOpravljenegaIntenzivnegaTecaja()}
                           label={'LETO OPRAVLJENEGA INTENZIVNEGA PROGRAMA ALI PROGRAMA VOZNIKA ZAČETNIKA'}
                           input={
                               <CvvTextInput type={'number'} min={1900} max={new Date().getFullYear()}
                                             invalid={!!store.validators.step3.letoOpravljenegaIntenzivnegaTecaja()}
                                             value={store.form.step3!.letoOpravljenegaIntenzivnegaTecaja! > 0 ? store.form.step3!.letoOpravljenegaIntenzivnegaTecaja! : ''}
                                             pattern={'[0-9]*'}
                                             onChange={(e) => store.form.step3!.letoOpravljenegaIntenzivnegaTecaja = Number(e.target.value.replace(/\D/g, ''))}/>
                           }/>}
        {store.config.s3?.letoOpravljene_1Stopnje &&
            <CvvInputField error={store.validators.step3.letoOpravljene1Stopnje()}
                           label={'LETO OPRAVLJENE 1. STOPNJE'}
                           input={
                               <CvvTextInput type={'number'} min={1900} max={new Date().getFullYear()}
                                             invalid={!!store.validators.step3.letoOpravljene1Stopnje()}
                                             value={store.form.step3!.letoOpravljene_1Stopnje! > 0 ? store.form.step3!.letoOpravljene_1Stopnje! : ''}
                                             pattern={'[0-9]*'}
                                             onChange={(e) => store.form.step3!.letoOpravljene_1Stopnje = Number(e.target.value.replace(/\D/g, ''))}/>
                           }/>}
        {store.config.s3?.krajRojstva &&
            <CvvInputField error={store.validators.step3.krajRojstva()} label={'KRAJ ROJSTVA'} input={
                <CvvTextInput
                    invalid={!!store.validators.step3.krajRojstva()} value={store.form.step3!.krajRojstva!}
                    onChange={(e) => store.form.step3!.krajRojstva = e.target.value.toUpperCase()}/>
            }/>}
        {(store.config.s3?.veljavnoVoznisko || store.config.s3?.veljavnoVozniskoKazenskeTocke) && <>
            <CvvCategoryHeader style={{marginTop: '52px'}}>
                Imam veljavno vozniško dovoljenje
            </CvvCategoryHeader>
            <CvvRadio
                name={'veljavno-voznisko'} id={'da'} checked={store.form.step3!.veljavnoVoznisko!} onChange={() => {
                store.form.step3!.veljavnoVoznisko = true;
                if (store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.zdravstveni_pregled) {
                    store.form.step3!.napotilo = mladi_voznik.KazenskeTockeNapotilo.sodisce;
                }
            }} label={'da'}/>
            <CvvRadio
                name={'veljavno-voznisko'} id={'ne'} checked={!store.form.step3!.veljavnoVoznisko} onChange={() => {
                store.form.step3!.veljavnoVoznisko = false;
                store.form.step3!.napotilo = mladi_voznik.KazenskeTockeNapotilo.zdravstveni_pregled;
            }} label={'ne'}/>
        </>}
        {store.config.s3?.veljavnoVozniskoKazenskeTocke && <>
            <CvvCategoryHeader style={{marginTop: '52px'}}>
                Kako ste bili napoteni na program?
            </CvvCategoryHeader>
            <CvvCollapsible expanded={!!store.form.step3!.veljavnoVoznisko}>
                <CvvRadio
                    name={'kt-napotilo'} id={'sodisce'}
                    checked={store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.sodisce} onChange={() => {
                        if (!store.form.step3!.veljavnoVoznisko) return;
                        store.form.step3!.napotilo = mladi_voznik.KazenskeTockeNapotilo.sodisce;
                }} label={'SODIŠČE'}/>
            </CvvCollapsible>
            <CvvCollapsible expanded={!store.form.step3!.veljavnoVoznisko}>
                <CvvRadio
                  name={'kt-napotilo'} id={'zdravniski'}
                  checked={store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.zdravstveni_pregled}
                  onChange={() => {
                      store.form.step3!.napotilo = mladi_voznik.KazenskeTockeNapotilo.zdravstveni_pregled;
                  }} label={'KONTROLNI ZDRAVSTVENI PREGLED'}/>
            </CvvCollapsible>
            <CvvCollapsible expanded={!!store.form.step3!.veljavnoVoznisko}>
                <CvvRadio
                    name={'kt-napotilo'} id={'prostovoljno'}
                    checked={store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.prostovoljno}
                    onChange={() => {
                        if (!store.form.step3!.veljavnoVoznisko) return;
                        store.form.step3!.napotilo = mladi_voznik.KazenskeTockeNapotilo.prostovoljno;
                    }} label={'PROSTOVOLJNO'}/>
            </CvvCollapsible>
            <CvvCollapsible expanded={store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.prostovoljno}>
                <CvvCheckbox
                    label={'Izjavljam, da se programa za izbris kazenskih točk udeležujem na lastno željo in nisem nobene od kazenskih točk pridobil/-a z vožnjo pod vplivom alkohola, prepovedanih drog in drugih psihoaktivnih snovi. V kazenski evidenci imam vpisane vsaj 4 in ne več kot 17 kazenskih točk (voznik začetnik - največ 6 kazenskih točk).'}
                    style={{fontWeight: 'bold', fontSize: '12px'}}
                    checked={store.step3.kazenskeSoglasje}
                    onChange={() => store.step3.kazenskeSoglasje = !store.step3.kazenskeSoglasje}/>
                {store.validators.step3.kazenskeSoglasje() && <div style={{color: CvvColors.error, fontSize: '12px', marginTop: '4px'}}>
                    {store.validators.step3.kazenskeSoglasje()}
                </div>}
            </CvvCollapsible>
            <CvvCollapsible expanded={store.form.step3!.napotilo !== mladi_voznik.KazenskeTockeNapotilo.prostovoljno}>
                <CvvCategoryHeader style={{marginTop: '52px'}}>
                    Napotilo
                </CvvCategoryHeader>
            </CvvCollapsible>
            <CvvCollapsible expanded={store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.sodisce}>
                <CvvInputField error={store.validators.step3.pristojnoSodisce()}
                               label={'PRISTOJNO SODIŠČE'}
                               input={
                                   <CvvTextInput
                                       invalid={!!store.validators.step3.pristojnoSodisce()}
                                       value={store.form.step3!.napotiloPristojnoSodisce!}
                                       onChange={(e) => store.form.step3!.napotiloPristojnoSodisce = e.target.value.toUpperCase()}
                                       {...store.form.step3!.napotilo !== mladi_voznik.KazenskeTockeNapotilo.sodisce && {tabIndex: -1}}
                                   />
                               }/>
                <CvvInputField error={store.validators.step3.pristojnoSodisce()}
                               label={'ŠTEVILKA NAPOTILA (EPVD ŠTEVILKA)'}
                               input={
                                   <CvvTextInput
                                       invalid={!!store.validators.step3.stevilkaNapotila()}
                                       value={store.form.step3!.napotiloStevilka!}
                                       onChange={(e) => store.form.step3!.napotiloStevilka = e.target.value}
                                       {...store.form.step3!.napotilo !== mladi_voznik.KazenskeTockeNapotilo.sodisce && {tabIndex: -1}}
                                   />
                               }/>

            </CvvCollapsible>
            <CvvCollapsible expanded={
              store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.sodisce ||
              store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.zdravstveni_pregled
            }>
                <CvvInputField error={store.validators.step3.datumNapotila()}
                               label={'DATUM NAPOTILA'}
                               input={
                                   <DatepickerStyles
                                     invalid={!!store.validators.step3.datumNapotila()}>
                                       <DatePicker
                                         inputRef={dateRef as RefObject<HTMLInputElement>}
                                         value={store.step3!.datumNapotila}
                                         format={'d. M. y'}
                                         onChange={(date?: Date) => store.step3.setDatumNapotila(date)}
                                         defaultActiveStartDate={nowMinus6M}
                                       />
                                   </DatepickerStyles>
                               }/>
            </CvvCollapsible>
            <CvvCollapsible expanded={
              store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.sodisce ||
              store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.zdravstveni_pregled
            }>
                <GmapsAddressPicker
                  label={'NASLOV ZA POŠILJANJE'}
                  address={store.form.step1!.mailingAddress!}
                  onPlaceSelected={(p) => store.setMailingAddress(p)}
                  noMap={true}
                />
            </CvvCollapsible>
            <CvvCollapsible expanded={
              store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.sodisce ||
              store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.zdravstveni_pregled
            }>
                <CvvInputField
                  label={store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.sodisce
                    ? 'SKLEP SODIŠČA'
                    : 'ZDRAVNIŠKO SPRIČEVALO'}
                  input={
                    <FileUploadInput
                      file={store.form.step3!.napotiloDokument ?? undefined}
                      onFileChanged={(f) => store.form.step3!.napotiloDokument = f}
                      extensions={['pdf', 'jpg', 'jpeg', 'png']}
                    />
                  }
                />
            </CvvCollapsible>

            <CvvCollapsible expanded={
              store.form.step3!.napotilo === mladi_voznik.KazenskeTockeNapotilo.prostovoljno && store.step3.kazenskeSoglasje
            }>
                <CvvInputField error={store.validators.step3.stKazenskihTock()} label={'KOLIKO KAZENSKIH TOČK IMATE VPISANIH V KAZENSKI EVIDENCI?'} input={
                    <CvvTextInput type={'numeric'} maxLength={2} invalid={!!store.validators.step3.stKazenskihTock()}
                                  value={store.form.step3!.stKazenskihTock! > 0 ? store.form.step3!.stKazenskihTock! : ''}
                                  pattern={'[0-9]*'}
                                  onChange={
                                      (e)=> {
                                          store.form.step3!.stKazenskihTock = Number(e.target.value.replace(/\D/g, ''));
                                      }}/>
                }/>
                <CvvInputField error={store.validators.step3.kazenskeTockeRazlog()} label={'ZARADI ČESA SO BILE PRIDOBLJENE?'} input={
                    <CvvTextInput
                      value={store.form.step3!.kazenskeTockeRazlog ?? ''}
                      onChange={(e) => store.form.step3!.kazenskeTockeRazlog = e.target.value}/>
                }/>
            </CvvCollapsible>
        </>}
        <CvvButton
            onClick={() => store.setStep(store.step + 1)}
            style={{marginTop: '64px'}}
            disabled={false}>
            <theme.textTheme.headline5.span>NAPREJ</theme.textTheme.headline5.span>
            <NextSvg height={'22px'} style={{marginLeft: 'auto'}}/>
        </CvvButton>
    </FormStepContainer>
})